export const errorMessages = {
  noSession: 'No User Session',
  failedLogin: 'Failed to Login',
  failedLoginRequest: 'Failed to initiate login',
  failedLogout: 'Failed to Logout',
  alreadySignedIn: 'Already signed in, redirecting',
  failedRegistration: 'Failed to register',
  failedRegistrationRequest: 'Failed to initiate registration',
  failedRecoveryRequest: 'Failed to initiate recovery',
  passwordResetTimeout: 'Password reset timeout, request new recovery',
  invalidSettingsFlow: 'Invalid or missing flow, request new recovery',
  unknownError: 'An unknown error occured',
  validationError: 'Invalid input values',
  noRedirectUrl: 'No redirect URL provided',
};

export const formErrorMessages = {
  noPaymentMethods: 'No payment methods available.',
  loadFailure: 'Failed to load payment methods. Please try again later.',
  countriesLoadFailure: 'Failed to load countries. Try reloading the page',
  loadingAreaError: 'Failed to get area. Try again later',
};
